import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {commons, ff, form, Loader, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Button, Card, CardBody, CardHeader, Col, Label, Row} from "reactstrap";
import {formValueSelector, reduxForm} from "redux-form";
import * as adresaFormatter from "../utils/adresaFormatter";
import KontaktniUdajePanel from "../components/KontaktniUdajePanel";
import {formatDate, formatTime, getMaximalniCas, getMinimalniCas, redirectToOrderStep} from "../utils/utils";
import * as steps from "../const/routes";
import * as EnumFormaDoruceni from "../api/gen/cgo/EnumFormaDoruceni";
import RadioField from "./fields/RadioField";
import NahraneSouboryPanel from "../components/NahraneSouboryPanel";
import ObjectSelect from "../components/ObjectSelect";
import * as ciselnikActions from "../actions/ciselnikActions";
import moment from "moment";
import * as subjektActions from "../actions/subjektActions";
import {toastr} from "react-redux-toastr";
import './DopravaForm.scss';
import {WithTranslation, withTranslation} from "react-i18next";

const {Form, FormActions, FormBody} = form;

/**
 * Formulář procesu objednávky - Doprava.
 */
class DopravaForm extends Component<WithTranslation> {

    static formName = 'DopravaForm';

    static propTypes = {
        pobockyList: PropTypes.array.isRequired, // seznam poboček
        zpusobyDopravyList: PropTypes.array.isRequired, // seznam způsobů dopravy
        adresyList: PropTypes.array.isRequired, // seznam adres uživatele a případně jeho společnosti
        zobrazovatCasOd: PropTypes.instanceOf(Date).isRequired, // minimální čas který lze vybrat při vyzvednutí na pobočce, platí jen pro výchozí pobočku
        zobrazovatCasDo: PropTypes.instanceOf(Date).isRequired, // maximální čas který lze vybrat při vyzvednutí na pobočce, platí jen pro výchozí pobočku
        krokCasMinut: PropTypes.number.isRequired, // velikost kroku ve výběru času
        zakazkaData: PropTypes.object.isRequired, // data prvního kroku - zakázky
        zakaznikData: PropTypes.object.isRequired, // data druhéko kroku - zákazníka
    };

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (values.naPobocku) {
            if (!values.pobockaId) {
                errors.pobockaId = t('validation.branch_required');
            }
            if (!values.datumVyzvednuti) {
                errors.datumVyzvednuti = t('delivery_date_required');
            }
            if (values.datumVyzvednuti && moment(values.datumVyzvednuti).startOf('day') < moment().startOf('day')) {
                errors.datumVyzvednuti = t('pickup_date');
            }
            if (!values.casVyzvednuti) {
                errors.casVyzvednuti = t('pickup_time_required');
            }
        } else {
            if (!values.datumDoruceni) {
                errors.datumDoruceni = t('validation.delivery_date_required');
            }
            if (values.datumDoruceni && moment(values.datumDoruceni).startOf('day') < moment().startOf('day')) {
                errors.datumDoruceni = t('validation.delivery_date_future')
            }
            // TODO berka tohle nezabere potom co ho změní automat při změně datumu nebo pobočky!
            if (!values.terminDopravaId || values.terminDopravaId === "") {
                errors.terminDopravaId = t('validation.delivery_time_required');
            }
            if (!values.ulice) {
                errors.ulice = t('validation.field_required');
            }
            if (!values.obec) {
                errors.obec = t('validation.field_required');
            }
            if (!values.psc) {
                errors.psc = t('validation.field_required');
            }
        }
        return errors;
    };

    constructor(props) {
        super(props);
        this.state = {
            zobrazovatCasOd: props.zobrazovatCasOd,
            zobrazovatCasDo: props.zobrazovatCasDo,
            pobockaErrorShown: false,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        this.fetchData();
        // Při přenačtení termínů dopravy vynutíme nastavení prvního - jinak se stává že je nastavený jiný než který je právě zobrazen v comboboxu
        const prevTerminy = prevProps.terminyList;
        const thisTerminy = this.props.terminyList;
        if (thisTerminy && (!prevTerminy || prevTerminy && prevTerminy.rows !== thisTerminy.rows) && thisTerminy.rows.length > 0) {
            this.props.change('terminDopravaId', thisTerminy.rows[0].id);
        }

        // Kontrola, že výchozí výdejní pobočka společnosti existuje v seznamu nabízených výdejních poboček
        const {naPobocku, pobockyList, aktivniSpolecnostDetail, t} = this.props;
        const {pobockaErrorShown} = this.state;
        if (naPobocku && pobockyList && aktivniSpolecnostDetail.fetched && !pobockaErrorShown) {
            const spolecnost = aktivniSpolecnostDetail.data;
            if (spolecnost.pobockaVydej) {
                const found = pobockyList.find(x => x.id === spolecnost.pobockaVydej.id);
                if (!found) {
                    toastr.error(t('validation.branch_invalid', {branchName: spolecnost.pobockaVydej.nazevPobocka}));
                    this.setState({pobockaErrorShown: true});
                    if (pobockyList.length > 0) {
                        this.props.change('pobockaId', pobockyList[0].id);
                    } else {
                        this.props.change('pobockaId', null);
                    }
                }
            }
        }
    }

    fetchData = () => {
        const {zpusobDopravaId, datumDoruceni} = this.props;
        if (zpusobDopravaId) {
            const datum = datumDoruceni && formatDate(datumDoruceni, null, "YYYY-MM-DD") || null;
            this.props.dispatch(ciselnikActions.fetchTerminyDopravyIfNeeded(zpusobDopravaId, datum, true));
        }
        this.props.dispatch(ciselnikActions.fetchFirmaIfNeeded());
    };

    handleZpusobDopravyChange = (zpusobDoprava) => {
        const {datumDoruceni} = this.props;
        this.props.dispatch(ciselnikActions.invalidateTerminyDopravy());
        this.props.change('terminDopravaId', null);
        this.props.change('naPobocku', zpusobDoprava.formaDoruceni === EnumFormaDoruceni.POB);
        if (zpusobDoprava.formaDoruceni === EnumFormaDoruceni.ADR) {
            const datum = datumDoruceni && formatDate(datumDoruceni, null, "YYYY-MM-DD") || null;
            this.props.dispatch(ciselnikActions.fetchTerminyDopravyIfNeeded(zpusobDoprava.id, datum, true));
        }
    };

    handleDatumDoruceniChange = (datumDoruceni) => {
        if (datumDoruceni.target) datumDoruceni = datumDoruceni.target.value;
        const {zpusobDopravaId} = this.props;
        if (zpusobDopravaId) {
            const datum = datumDoruceni && formatDate(datumDoruceni, null, "YYYY-MM-DD") || null;
            this.props.dispatch(ciselnikActions.fetchTerminyDopravyIfNeeded(zpusobDopravaId, datum, true));
            this.props.change('terminDopravaId', null);
        }
    };

    handleAdresaChange = (adresa) => {
        this.props.change('ulice', adresa.ulice);
        this.props.change('psc', adresa.psc);
        this.props.change('obec', adresa.obec);
        this.props.change('stat', adresa.stat);
    };

    clearAdresa = () => {
        this.props.change('adresa', null);
    };

    handlePobockaChange = (event) => {
        const pobockaId = event && event.target.value && parseInt(event.target.value) || this.props.pobockaId && parseInt(this.props.pobockaId);
        this.updateOmezeniCasu(pobockaId, this.props.datumVyzvednuti);
    };

    handleDatumVyzvednutiChange = (event) => {
        this.updateOmezeniCasu(this.props.pobockaId && parseInt(this.props.pobockaId), event.target.value);
    };

    updateOmezeniCasu = (pobockaId, datumVyzvednuti) => {
        const {pobockyList, firmaDetail} = this.props;
        const pobocka = pobockyList.find(p => p.id === pobockaId);
        const min = getMinimalniCas(firmaDetail.data, pobocka, datumVyzvednuti);
        const max = getMaximalniCas(firmaDetail.data);
        this.setState({zobrazovatCasOd: min, zobrazovatCasDo: max}, () => this.props.change('casVyzvednuti', formatTime(min)));
    };

    validateCasVyzvednuti = (casVyzvednuti) => {
        const {t} = this.props;
        const {zobrazovatCasOd, zobrazovatCasDo} = this.state;
        if (!zobrazovatCasOd || !zobrazovatCasDo || !casVyzvednuti) {
            return;
        }
        const casOd = commons.removeDate(zobrazovatCasOd);
        const casDo = commons.removeDate(zobrazovatCasDo);
        if (casOd > casDo) {
            return t('validation.date_invalid_time_change');
        }
        const selectedCas = commons.removeDate(moment(casVyzvednuti, "HH:mm:ss").toDate());
        if (selectedCas < casOd || selectedCas > casDo) {
            return t('validation.date_out_of_range');
        }
    };

    render() {
        const {onClose, handleSubmit, submitting, error, pobockyList, adresyList, zakazkaData,
            zakaznikData, naPobocku, zpusobyDopravyList, krokCasMinut, terminyList, firmaDetail, t} = this.props;
        const {zobrazovatCasOd, zobrazovatCasDo} = this.state;

        if (!firmaDetail.fetched) {
            return <Loader/>;
        }

        const fileMetas = zakazkaData && zakazkaData.fileMetas || [];
        const timeRangeMakesSense = zobrazovatCasOd && zobrazovatCasDo &&
            commons.removeDate(zobrazovatCasDo) >= commons.removeDate(zobrazovatCasOd);

        return <Form onSubmit={handleSubmit} horizontal className={"doprava-form"}>
            <FormBody>
                <Row>
                    <Col xs={12} md={8}>
                        <Card className="h-100">
                            <CardHeader>
                                <h2>{t('order.choose_delivery_method')}</h2>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs={12} sm={8}>
                                        {/*ListSelect vrací celý objekt a nepředvybere se proto podle default props*/}
                                        {/*<ff.ListSelect*/}
                                        {/*name="zpusobDoprava"*/}
                                        {/*label={false}*/}
                                        {/*items={zpusobyDopravyList}*/}
                                        {/*renderItem={i => i.nazevDoprava}*/}
                                        {/*onChange={this.handleZpusobDopravyChange}*/}
                                        {/*/>*/}
                                        {zpusobyDopravyList.map(zpusobDoprava =>
                                            <RadioField
                                                key={zpusobDoprava.id}
                                                label={zpusobDoprava.nazevDoprava}
                                                name="zpusobDopravaId"
                                                value={zpusobDoprava.id}
                                                onChange={this.handleZpusobDopravyChange.bind(this, zpusobDoprava)}
                                            />
                                        )}
                                        {error && <p className="text-danger">{error}</p>}
                                        {naPobocku === true ? <div>
                                                <Row className="form-group">
                                                    <Col>
                                                        <ff.Select label={t('choose_branch')} name="pobockaId" disabled={submitting} onChange={this.handlePobockaChange}>
                                                            {pobockyList.map(pobocka =>
                                                                <option key={pobocka.id} value={pobocka.id}>{pobocka.nazevPobocka}</option>
                                                            )}
                                                        </ff.Select>
                                                    </Col>
                                                </Row>
                                                <Row className="form-group">
                                                    <Col xs={12} sm={4}>
                                                        <Label className="col-form-label">{t('order.date_and_time_of_pickup')}</Label>
                                                    </Col>
                                                    <Col xs={12} sm={8} className={"inline-input min-height-field"}>
                                                        <ff.SimpleDate min={new Date()} label={false} name="datumVyzvednuti" onChange={this.handleDatumVyzvednutiChange} />
                                                        <ff.Time name="casVyzvednuti" min={zobrazovatCasOd} max={zobrazovatCasDo} step={krokCasMinut} validate={this.validateCasVyzvednuti} label={false} disabled={!timeRangeMakesSense} addonsAfter={<Col xs={0} sm={6}/>} />
                                                    </Col>
                                                </Row>
                                            </div> :
                                        naPobocku === false ? <div>
                                                <Row>
                                                    <Col xs={12} sm={6}>
                                                        <ff.SimpleDate min={new Date()} label={t('order.delivery_date')} name="datumDoruceni" onChange={this.handleDatumDoruceniChange}/>
                                                    </Col>
                                                </Row>
                                                <ff.Select label={t('delivery_time')} name="terminDopravaId" disabled={submitting}>
                                                    {terminyList.rows.map(r => <option key={r.id} value={r.id}>{r.nazevTermin}</option>)}
                                                </ff.Select>
                                                <Row className={"mt-3"}>
                                                    <Col>
                                                        <ObjectSelect
                                                            label={t('choose_address')}
                                                            name="adresa"
                                                            items={adresyList}
                                                            getItemValue={(item) => item ? adresaFormatter.getUplnaAdresa(item) : ""}
                                                            disabled={submitting}
                                                            onChange={this.handleAdresaChange}
                                                            showEmpty={true} // nutné aby zafungovalo clearAdresa
                                                        />
                                                        <ff.String label={t('street')} name="ulice" disabled={submitting} onChange={this.clearAdresa}/>
                                                        <ff.Number label={t('zip')} name="psc" disabled={submitting} onChange={this.clearAdresa}/>
                                                        <ff.String label={t('city')} name="obec" disabled={submitting} onChange={this.clearAdresa}/>
                                                        <ff.String label={t('country')} name="stat" disabled={submitting} onChange={this.clearAdresa}/>
                                                    </Col>
                                                </Row>
                                            </div> : null}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs={12} md={4}>
                        <NahraneSouboryPanel soubory={fileMetas.map(meta => meta.podslozky + meta.name)}/>
                        <KontaktniUdajePanel kontaktniUdaje={zakaznikData}/>
                    </Col>
                    <Col xs={12} className="submit-button-panel">
                        <Button color="secondary" type="button" onClick={redirectToOrderStep.bind(this, steps.ZAKAZNIK, this.props)}>{t('buttons.back')}</Button>
                        <Button color="primary">{t('order.next_step')}</Button>
                    </Col>
                </Row>
            </FormBody>
            <FormActions onClose={onClose} disabled={submitting}/>
        </Form>
    }
}

const selector = formValueSelector(DopravaForm.formName);

const mapStateToProps = state => ({
    naPobocku: selector(state, 'naPobocku'),
    pobockaId: selector(state, 'pobockaId'),
    datumDoruceni: selector(state, 'datumDoruceni'),
    datumVyzvednuti: selector(state, 'datumVyzvednuti'),
    zpusobDopravaId: selector(state, 'zpusobDopravaId'),
    terminyList: utils.storeFromArea(state, ciselnikActions.TERMINY_DOPRAVY_LIST_AREA),
    firmaDetail: utils.storeFromArea(state, ciselnikActions.FIRMA_AREA),
    aktivniSpolecnostDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_AKTIVNI_SPOLECNOST_AREA)
});

export default withTranslation()(withRouter(connect(mapStateToProps)((reduxForm({
    form: DopravaForm.formName,
    validate: DopravaForm.validate,
})(DopravaForm)))));
